import { j as P } from "../../jsx-runtime.BREq8dyb.js";
import { useForkRef as d } from "@decentriq/hooks";
import { Transition as $ } from "notistack";
import { forwardRef as b, useRef as k, cloneElement as v } from "react";
import { getTransitionProps as p, createTransition as i, reflow as F } from "../../utils/index.js";
function c(o) {
  return `scale(${o}, ${o ** 2})`;
}
const I = {
  entered: {
    opacity: 1,
    transform: "none"
  },
  entering: {
    opacity: 1,
    transform: c(1)
  }
}, N = b((o, y) => {
  const {
    children: s,
    in: f,
    style: a,
    timeout: l = 300,
    onEnter: u,
    onEntered: x,
    onExit: E,
    onExited: h,
    ...R
  } = o, m = k(null), g = d(s.ref, m), j = d(g, y), w = (t, e) => {
    F(t);
    const {
      duration: n,
      delay: r,
      easing: G
    } = p({
      mode: "enter",
      style: a,
      timeout: l
    });
    t.style.transition = [i("opacity", {
      delay: r,
      duration: n
    }), i("transform", {
      delay: r,
      duration: n * 0.666,
      easing: G
    })].join(","), u?.(t, e);
  }, T = (t) => {
    const {
      duration: e,
      delay: n,
      easing: r
    } = p({
      mode: "exit",
      style: a,
      timeout: l
    });
    t.style.transition = [i("opacity", {
      delay: n,
      duration: e
    }), i("transform", {
      delay: n || e * 0.333,
      duration: e * 0.666,
      easing: r
    })].join(","), t.style.opacity = "0", t.style.transform = c(0.75), E?.(t);
  };
  return /* @__PURE__ */ P.jsx($, { appear: !0, in: f, nodeRef: m, onEnter: w, onEntered: x, onExit: T, onExited: h, timeout: l, ...R, children: (t, e) => v(s, {
    ref: j,
    style: {
      opacity: 0,
      transform: c(0.75),
      visibility: t === "exited" && !f ? "hidden" : void 0,
      ...I[t],
      ...a,
      ...s.props.style
    },
    ...e
  }) });
});
N.displayName = "Grow";
export {
  N as default
};
//# sourceMappingURL=Grow.js.map
